export const APIConstant = {
  auth: {
    registerIndividual: '/',
    login: '/Auth/Login',
    register: '/Auth/Register',
    verifyEmail: '/Auth/VerifyEmail',
    sendEmailVerificationCode: '/Auth/SendEmailVerification',
    sendPasswordResetEmail: '/Auth/SendEmailPasswordReset',
    resetPassword: '/Auth/ResetPassword',
    changePassword: '/Auth/ChangePassword',
    registerGuest: '/Auth/RegisterGuest',
  },
  lookup: {
    userType: '/GetLookUps/GetLkUserTypes',
    state: '/GetLookUps/GetLkStates',
    stateWithLga: '/GetLookUps/GetLkStatesWithLgas',
    gender: '/GetLookUps/GetLkGenders',
    lga: '/GetLookUps/GetLkLgas',
    countries: '/GetLookUps/GetLkCountries',
    category: '/GetLookUps/GetLkCategories',
    certificationStatus: '/GetLookUps/GetLkCertificationStatus',
    factoryStatus: '/GetLookUps/GetLkFactoryStatus',
    departmentUnits: '/GetLookUps/GetLkDepartmentUnits',
    productionStatus: '/GetLookUps/GetLkProductionStatus',
    productionUnits: '/GetLookUps/GetLkProductionUnits',
    factoryProfile: '/GetLookUps/GetLkFactoryProfile',
    location: '/GetLookUps/GetLkLocation',
    operationalAndCertification: '/GetLookUps/GetLkOperationalAndCertification',
    productAndLaboratory: '/GetLookUps/GetLkProductAndLaboratory',
    nextOfficersByRoleName: '/GetLookUps/GetNextOfficersByRoleName',
    areaOffices: '/GetLookUps/GetLkAreaOffices',
    companies: '/GetLookUps/GetLkCompanies',
    inspectionResults: '/GetLookUps/GetLkInspectionResults',
    inspectionTypes: '/GetLookUps/GetLkInspectionTypes',
  },
  factory: {
    getDashboard: '/Factories/GetDashboard',
    getDetails: '/Factories/GetDetails',
    getAllFactories: '/Factories/GetAllFactories',
    getAllLegacyFactories: '/Factories/GetLegacyFactories',
    getLegacyFactoryDetail: '/Factories/GetLegacyFactory',
    getAllCompanies: '/Factories/GetSearchablePaginatedCompanies',
    getAllFactoriesPending: '/Factories/GetAllFactoriesPending',
    getAllFactoriesForExport: '/Factories/GetAllFactoriesForExport',
    saveFactoryProfile: '/Factories/SaveFactoryProfile',
    submitFactoryProfile: '/Factories/SubmitFactoryProfile',
    approveFactoryProfile: '/Factories/ApproveFactoryProfile',
    declineFactoryProfile: '/Factories/DeclineFactoryProfile',
    getListSimilarLegacyFactories: '/Factories/GetListSimilarLegacyFactories',
    checkForSimilarLegacyFactory: '/Factories/SPCheckSimilarLegacy',
    getFactoryInspectionReports: '/Factories/GetAllInspections',
  },
  inspection: {
    submitInpection: '/Inspection/SubmitInspectionReport',
  },
  verify: {
    nin: '/Verify/VerifyNin',
    phone: '/Sms/SendVerifyCode',
    verifyCode: '/Sms/VerifyCode',
  },
  user: {
    preregistration: '/User/GetUserRegistrationByNin',
    preRegisterUser: '/Auth/PreRegister',
    getAllUsers: '/User/GetAllUsers',
    getUserProfileByEmail: '/User/GetUserProfileByEmail',
    deleteUser: '/User/DeleteUser',
    deactivateUser: '/User/DeactivateUser',
    reactivateUser: '/User/ReactivateUser',
    createAdminUsers: '/User/CreateAdminUsers',
    changeAdminOffice: '/User/ChangeAdminOffice',
  },
  role: {
    getAllRoles: '/Role/GetAllRoles',
    getRole: '/Role/GetRole',
    getUserRoles: '/Role/GetUserRoles',
    createRoles: '/Role/CreateRoles',
    deleteRoles: '/Role/DeleteRoles',
    assignRoleToUsers: '/Role/AssignRoleToUsers',
    unassignRolesFromUsers: '/Role/UnassignRolesToUsers',
    addUserClaims: '/Role/AddUserClaims',
    removeUserClaims: '/Role/RemoveUserClaims',
  },
  charts: {
    baseURL: 'http://my-json-server.typicode.com/apexcharts/apexcharts.js',
    paths: {
      yearly: '/yearly',
    },
  },
  analytics: {
    getAnalyticsDashboard: '/Analytics/GetAnalyticsDashboard',
    getAnalyticsRegions: '/Analytics/GetAnalyticsRegions',
    getAnalyticsFactorySize: '/Analytics/GetAnalyticsFactorySize',
    getAnalyticsFactoryStatus: '/Analytics/GetAnalyticsFactoryStatus',
  },
};
